// Trip parameters the car-choice email priced the trip with (DEVA-280, decision on DEVA-185):
// Zoho puts them into the link (DEVA-279), and the PATCH of the order carries them, so a trip
// the customer changed on the site after the email is recalculated by the backend with the
// email's parameters instead of dropping the email's price. A parameter the link does not
// carry is not sent: emails sent before the template change behave as before.
const LINK_TO_ORDER_FIELDS: Record<string, string> = {
  duration: 'hours',
  extraKms: 'extra_kms',
  pickup: 'pickup',
  dropoff: 'dropoff'
}

export const mailCarTripParams = (query: URLSearchParams): Record<string, string> => {
  const params: Record<string, string> = {}

  for (const [linkKey, orderField] of Object.entries(LINK_TO_ORDER_FIELDS)) {
    const value = query.get(linkKey)?.trim()
    if (value) {
      params[orderField] = value
    }
  }

  return params
}

// The backend answers 422 when the link's parameters do not pass validation (e.g. a duration
// outside 2–10). Nothing was changed by that request, so the customer is told to contact us
// instead of staying on a loader that never ends.
export const MAIL_CAR_LINK_REJECTED_MESSAGE =
  'We could not open this offer from the email. Please contact us and we will update your booking.'
